import {register} from '@shopify/theme-sections';
import Flickity from 'flickity';
import 'flickity-imagesloaded';

export default register('sub-collection-slider', {
  onLoad() {
    this.sliderId = '#sub-collection-slider--' + this.id;
    const thisSlider = document.querySelector('#sub-collection-slider--' + this.id);
    const countRowSub = document.querySelectorAll(`#sub-collection-slider--${this.id} .row-sub`)

    if (countRowSub.length > 3) {
      new Flickity(thisSlider, {
        // options
        freeScroll: false,
        contain: true,
        prevNextButtons: false,
        pageDots: true,
        imagesLoaded: true,
        setGallerySize: true,
        groupCells: true,
        cellAlign: 'center',
        watchCSS: true,
        wrapAround: false,
        autoPlay: false
      });
    }
  },
});
